import { yenKanji } from '~/lib/price'
import { FlowerCollectionProduct } from '~/api-client/data-contracts'

type Props = {
  inBulkProducts: FlowerCollectionProduct[]
  selected: FlowerCollectionProduct | null
  onChange: (product: FlowerCollectionProduct | null) => void
}

export const VaseSelector: React.FC<Props> = ({ inBulkProducts, selected, onChange }) => {
  const vases = inBulkProducts.filter(v => v !== undefined)

  const buttonClass = (vase: FlowerCollectionProduct) => {
    if (vase.attributes.on_sale) {
      if (selected?.id === vase.id) {
        return 'border-black border-2 cursor-pointer'
      } else {
        return 'border-gray m-px cursor-pointer hover:border-black'
      }
    } else {
      return 'border-gray opacity-50 cursor-default'
    }
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      {vases.map((vase) => (
        <button
          key={vase.id}
          type="button"
          disabled={!vase.attributes.on_sale}
          onClick={() => onChange(vase)}
          className={`rounded-xl border overflow-hidden transition-colors flex-1 flex flex-col ${buttonClass(vase)}`}
        >
          <div className="aspect-square bg-bg overflow-hidden relative">
            <img src={vase.attributes.image_medium_url} alt={vase.attributes.name} className="w-full h-full object-cover" />
            {!vase.attributes.on_sale && (
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="bg-black/70 text-white text-[11px] font-medium px-3 py-1 rounded-full">在庫切れ</span>
              </div>
            )}
          </div>
          <div className="p-2 flex flex-col items-start">
            <p className="text-[11px] text-black font-medium leading-tight">{vase.attributes.name}</p>
            <div className="flex items-baseline gap-1.5 mt-1">
              <p className="text-[12px] font-medium text-red-500">{yenKanji(vase.attributes.bulk_discounted_price)}</p>
              <p className="text-[10px] text-dark-gray line-through">{yenKanji(vase.attributes.original_price)}</p>
            </div>
            <span className="inline-block bg-red-500 text-white text-[9px] font-medium px-1.5 py-0.5 rounded mt-1">20%OFF</span>
          </div>
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(null)}
        className={`rounded-xl border cursor-pointer transition-colors flex items-center justify-center md:flex-1 ${selected === null ? 'border-black border-2' : 'border-gray m-px hover:border-black'}`}
      >
        <p className={`text-[12px] font-medium ${selected === null ? "text-black" : "text-dark-gray"}`}>選択しない</p>
      </button>
    </div>
  )
}
